<div class="container-fluid widget-wrapper">
  <div class="row widget-header">
    <div class="col-lg-12">
      <h2>Risk Overview
        <a class="btn btn-link help-icon p-0" data-placement="top" data-toggle="tooltip" enTooltip
           title="Pixalate's unique advertising risk assessment based on blended risk factors including brand safety, invalid traffic and ad inventory">
          <img src="/assets/images/icon-indicator-info.svg" alt="Info Icon"/>
        </a>
        <ng-container *ngTemplateOutlet="swiperControls"></ng-container>
      </h2>
    </div>
  </div>
  <div class="row widget-body p-0">
    <div class="col-lg-12">
      <domain-overview-risk [isFollowing]="isFollowing" [data]="data" (anchorClick)="anchorClick.emit($event)">
      </domain-overview-risk>
    </div>
  </div>
</div>
